.c2{justify-content:flex-end;}